import { Button, Flex, Text } from "@chakra-ui/react";
import {
  BsCameraVideo,
  BsCameraVideoOff,
  BsMic,
  BsMicMute,
  BsRecordCircle,
} from "react-icons/bs";
import { MdGroupAdd } from "react-icons/md";
import LiveStreamChat from "./LiveStreamChat";
import { FaShareSquare } from "react-icons/fa";
import { useState } from "react";
import useSmallScreen from "../../../../components/useSmallScreen";
function LiveStreamBottomSmallScreenControls({
  showFullScreen,
  viewingLiveStream,
}) {
  const [smallScreen] = useSmallScreen();
  const [muteMic, setMuteMic] = useState(true);
  const [showCam, setShowCam] = useState(false);
  let btnStyle = {
    size: "xs",
    p: "15px 15px",
    fontSize: ".8em",
    borderRadius: "9px",
    bg: "#D9D9D9",
    color: "#000",
  };
  return (
    <Flex
      gap={["5px", "40px"]}
      flexWrap={[!viewingLiveStream ? "wrap" : "nowrap", "nowrap"]}
      flexDir={"row"}
      alignItems={["flex-end", "flex-end"]}
      position={"absolute"}
      bottom={["40px", "30px"]}
      px={viewingLiveStream ? "20px" : "unset"}
      right={viewingLiveStream ? "unset" : "20px"}
      left="0"
      w={viewingLiveStream ? "100%" : "unset"}
      justifyContent={viewingLiveStream ? "space-between" : "unset"}
      pb={smallScreen && !showFullScreen ? "20px" : "unset"}
    >
      <Flex
        flexDirection={"row"}
        alignItems={"flex-end"}
        w="100%"
        gap={["5px", "20px"]}
        justifyContent="space-between"
      >
        <LiveStreamChat viewingLiveStream={viewingLiveStream} />
        {viewingLiveStream && (
          <Flex
            flexDirection={"row"}
            alignItems="center"
            bg={!smallScreen ? "#5C5B5B" : "unset"}
            borderRadius={"10px"}
            p={["unset", "1px 10px"]}
            fontWeight={"600"}
            gap={["unset", "10px"]}
            color="#fff"
            cursor={"pointer"}
          >
            <MdGroupAdd fontSize={!smallScreen ? "3em" : "3em"} />
            {!smallScreen && <Text>Join Stream</Text>}
          </Flex>
        )}

        {!viewingLiveStream && (
          <Flex gap={"20px"} flexDir={"row"} alignItems="center">
            <Button
              {...btnStyle}
              color="#fff"
              bg="#FF2121"
              mb={smallScreen ? "10px" : "unset"}
            >
              End
            </Button>
          </Flex>
        )}
      </Flex>

      {!viewingLiveStream && (
        <Flex
          alignItems={"center"}
          gap={["30px", "50px"]}
          position="absolute"
          flexDir={"column"}
          right="5px"
          top="-150%"
        >
          {muteMic ? (
            <BsMicMute
              cursor={"pointer"}
              fontSize={"2.5em"}
              color={btnStyle?.bg}
              onClick={() => setMuteMic((prev) => !prev)}
            />
          ) : (
            <BsMic
              cursor={"pointer"}
              fontSize={"2.5em"}
              color={btnStyle?.bg}
              onClick={() => setMuteMic((prev) => !prev)}
            />
          )}

          {showCam ? (
            <BsCameraVideo
              cursor={"pointer"}
              fontSize={"2.5em"}
              color={btnStyle?.bg}
              onClick={() => setShowCam((prev) => !prev)}
            />
          ) : (
            <BsCameraVideoOff
              cursor={"pointer"}
              fontSize={"2.5em"}
              color={btnStyle?.bg}
              onClick={() => setShowCam((prev) => !prev)}
            />
          )}
          <Flex gap="20px" flexDir={"column"} alignItems="center">
            <BsRecordCircle
              cursor={"pointer"}
              fontSize={"2.5em"}
              color={btnStyle?.bg}
            />
            <FaShareSquare
              cursor={"pointer"}
              fontSize={"2.5em"}
              color={btnStyle?.bg}
            />
          </Flex>
        </Flex>
      )}
      <Flex alignItems={"center"} gap={["5px", "50px"]}>
        {viewingLiveStream && (
          <Button {...btnStyle} p="20px 15px" color="#fff" bg="#FF2121">
            Leave
          </Button>
        )}
      </Flex>
    </Flex>
  );
}

export default LiveStreamBottomSmallScreenControls;
